import styled from 'styled-components'
import { Info, InfoSet } from 'ui/components'

const NotesWrapper = styled.div`
  width: 700px;
  margin-bottom: 28px;
`

const NotesInfo = styled(Info)`
  padding-bottom: 10px;
`

const MediaInfo = styled(Info)`
  padding-bottom: 20px;
`

const MediaInfoSet = styled(InfoSet)`
  padding: 20px 0;
  margin-bottom: 36px;
`

export const s = {
  MediaInfoSet,
  MediaInfo,
  NotesInfo,
  NotesWrapper
}
